"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBaseApi = exports.SEARCH_API_ERROR = exports.FACET_PREFIX = exports.PAGE_SIZE = exports.MAX_PAGE_SIZE = void 0;
const tslib_1 = require("tslib");
const app_1 = require("app");
const json2typescript_1 = require("json2typescript");
const UtilService_1 = require("../UtilService");
exports.MAX_PAGE_SIZE = 2147483647;
exports.PAGE_SIZE = 10;
exports.FACET_PREFIX = 'facet_';
exports.SEARCH_API_ERROR = 'SEARCH_API_ERROR';
class SearchBaseApi extends app_1.BaseApi {
    constructor() {
        super(...arguments);
        this.buildUrl = (endPoint, params) => `${endPoint}?${this.buildQuery(params)}`;
        this.retryCallApiOnFail = (urlWithParams) => UtilService_1.UtilService.PromiseRetryPolicy(super.callApi.bind(this, urlWithParams, {}), 3);
    }
    doSearch(params, classReference) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.getData(params).then(data => {
                const jsonConvert = new json2typescript_1.JsonConvert();
                return jsonConvert.deserialize(data, classReference);
            });
        });
    }
    // Extended from BaseApi
    callApi(url, params) {
        const urlWithParams = this.buildUrl(url, params);
        return this.retryCallApiOnFail(urlWithParams);
    }
    // Extended from BaseApi
    throwException(message, responseData, _name = '') {
        return super.throwException(message, responseData, exports.SEARCH_API_ERROR);
    }
    // Extended from BaseApi
    createHeaders() {
        return {
            requestId: UtilService_1.UtilService.newUUID(),
        };
    }
}
exports.SearchBaseApi = SearchBaseApi;
